import { db } from "../firebase-config";
import { collection, setDoc, query, doc, onSnapshot, deleteDoc, getDoc } from "firebase/firestore";

// Update a unit of measure with a structured response
export const updateUnitOfMeasure = async (organization, uomData) => {
    try {
        const uomRef = doc(db, "organizations", organization, "unit_of_measure", uomData.id);
        await setDoc(uomRef, { capacity: uomData.capacity }, { merge: true });
        return { success: true, error: null };
    } catch (error) {
        console.error("Error updating unit of measure:", error);
        return { success: false, error: error.message || 'Failed to update unit of measure' };
    }
};

// Add a new unit of measure with a structured response
export const addUnitOfMeasure = async (organization, uomId, capacity) => {
    try {
        const uomRef = doc(db, "organizations", organization, "unit_of_measure", uomId);
        
        // Check if document already exists
        const docSnap = await getDoc(uomRef);
        if (docSnap.exists()) {
            return { 
                success: false, 
                error: 'Unit of measure with this name already exists' 
            };
        }

        await setDoc(uomRef, { capacity });
        return { success: true, error: null };
    } catch (error) {
        console.error("Error adding unit of measure:", error);
        return { success: false, error: error.message || 'Failed to add unit of measure' };
    }
};

export const deleteUnitOfMeasure = async (organization, uomId) => {
    try {
        const uomRef = doc(db, "organizations", organization, "unit_of_measure", uomId);
        await deleteDoc(uomRef);
        return { success: true, error: null };
    } catch (error) {
        console.error("Error deleting unit of measure:", error);
        return { success: false, error: error.message || 'Failed to delete unit of measure' };
    }
};

// Snapshot listener for all units of measure
export const UOMsSnapshotListener = (organization, onUnitOfMeasureUpdate) => {
    const uomQuery = query(collection(db, "organizations", organization, "unit_of_measure"));
    const unsubscribe = onSnapshot(uomQuery, (querySnapshot) => {
        const uomItems = [];
        querySnapshot.forEach((doc) => {
            uomItems.push({ id: doc.id, ...doc.data() });
        });
        onUnitOfMeasureUpdate(uomItems);
    });
    return () => unsubscribe();
};

// Snapshot listener for a specific unit of measure
export const UOMSnapshotListener = (organization, id, onUOMUpdate) => {
    const uomDocRef = doc(db, "organizations", organization, "unit_of_measure", id);

    const unsubscribe = onSnapshot(uomDocRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
            onUOMUpdate({ id: docSnapshot.id, ...docSnapshot.data() });
        } else {
            onUOMUpdate(null);
        }
    });
    return unsubscribe;
};
